<template>
  <v-layout height="600" class="">    
    <v-layout v-if="false"> 
        <mbs-page-spinner :show="true" />  
    </v-layout>     
    <v-container v-else grid-list-lg>  
        <!-- <v-card>
            <div class="printer-connect">
                <p v-if="connectedAddress">Connected: {{ connectedAddress }}</p>
                <p v-else>No printer connected</p>

                <button @click="refresh">Refresh paired devices</button>
                <button @click="bus.openPairingSettings()">Pair new device</button>

                <ul>
                <li v-for="d in devices" :key="d.address">
                    {{ d.name }} ({{ d.address }})
                    <button :disabled="bus.connecting" @click="bus.connect(d.address)">
                        {{ bus.connectedAddress === d.address ? 'Connected' : 'Connect' }}
                    </button>
                </li>
                </ul>

                <p v-if="bus.error" class="error">{{ bus.error }}</p>
            </div>
        </v-card>   
        <v-btn color="success" @click="Z108PRINTER">BluetoothPrinter</v-btn>  -->
        <!-- <v-btn color="success" @click="LAN_SET">LAN Set</v-btn>  -->
        <!-- <v-btn color="success" @click="test_mra">Test MRA</v-btn>  -->
        <v-layout row wrap>  
            <!-- //others -->
            <v-flex xs6 sm4 lg3 v-for="(link, index) in MyLinks" :key="index">
                <v-hover>
                    <template v-slot="{ hover  }">
                        <!-- :to="link.link" -->
                        <v-card  
                           
                            :elevation="hover ?12:''"
                            hover  rounded="lg"
                            height="100%"> 
                            <div v-if="MBS.actions.TEXT_UP(link.name) === MBS.actions.TEXT_UP('My profile')">
                                <v-img v-if="ud?ud.photoURL:false" 
                                    aspect-ratio="1.8" 
                                    :src="ud.photoURL"
                                    lazy-src="https://picsum.photos/10/6?image=3"  >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center">
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"
                                                /> 
                                        </v-row>
                                    </template>
                                </v-img>
                                    
                                <v-responsive  v-else   
                                    class="primary darken-1"
                                    aspect-ratio="1.8" > 
                                    <v-layout fill-height justify-center align-center>
                                        <v-avatar
                                            size="80"
                                            color="primary darken-2" > 
                                            <span class="white--text headline">
                                                {{us.displayName ? us.displayName[0] : ""}}
                                            </span>  
                                        </v-avatar>
                                    </v-layout>
                                </v-responsive> 
                            </div> 

                            <!--Not my profile--> 
                            <v-responsive v-else aspect-ratio="1.5"  >
                                <v-card height="100%" :color="link.image_background_color" tile>
                                    <v-layout v-if="false" class="ma-0" align-center justify-center fill-height > 
                                        <v-card color="transparent" :width="link.image_size?link.image_size+'%':'50%'" tile flat>
                                            <v-img   
                                                position="center"
                                                :src="link.image?link.image:MBS.data.noImg" > 
                                                <template v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"
                                                        ></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>  
                                        </v-card>
                                    </v-layout>
                                    <v-layout v-else-if="link.icon" class="ma-0" fill-height justify-center align-center>
                                        <v-icon size="60">{{link.icon}}</v-icon>
                                    </v-layout>  
                                </v-card>
                            </v-responsive>
                            <v-card-title >
                                <v-layout class="ma-0">
                                    <div class="headline" >{{link.name}}</div>
                                    <v-spacer></v-spacer> 
                                    <!-- <v-tooltip bottom  > 
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" icon >
                                                <v-icon color="primary">info_outline</v-icon>
                                            </v-btn> 
                                        </template>
                                        <span>More Info</span>
                                    </v-tooltip>  -->
                                </v-layout>
                            </v-card-title> 
                        </v-card> 
                    </template>
                </v-hover>
            </v-flex>

            <v-flex xs6 sm4 lg3 v-for="(link, index) in ProcessingOrders" :key="'processing_'+index" >
                <v-hover>
                    <template v-slot="{ hover  }">
                        <v-card  
                            :to="link.link"
                                
                            :elevation="hover ?12:''" class="b2"
                            hover  rounded="xl"
                            height="100%">  
                            <v-responsive  aspect-ratio="1.5"  >
                                <v-card rounded="xl" height="100%" :color="link.image_background_color" >
                                    <v-layout class="ma-0" align-center justify-center fill-height > 
                                        <v-card rounded="xl" color="transparent" height="100%" 
                                            :width="link.image_size?link.image_size+'%':'50%'" tile flat>
                                            <v-menu    offset-y v-if="false">
                                                <template v-slot:activator="{ on }">
                                                    <div>
                                                        <v-layout  class="py-5" > 
                                                            <v-spacer></v-spacer> 
                                                            <v-btn 
                                                                dark
                                                                icon
                                                                v-on="on" >
                                                                <v-icon>mdi-dots-vertical</v-icon>
                                                            </v-btn> 
                                                        </v-layout> 
                                                    </div>
                                                </template> 
                                                <v-list v-if="true"> 
                                                    <v-list-item @click="VIEW_ACCOUNT(link)">
                                                        <v-list-item-action><v-icon>mdi-eye</v-icon></v-list-item-action>
                                                        <v-list-item-title>View Account</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="EDIT_ACCOUNT(link)">
                                                        <v-list-item-action><v-icon>edit</v-icon></v-list-item-action>
                                                        <v-list-item-title>Edit Account</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="ARCHIVE_ACCOUNT(link)">
                                                        <v-list-item-action><v-icon>delete</v-icon></v-list-item-action>
                                                        <v-list-item-title>Archive Account</v-list-item-title>
                                                    </v-list-item>
                                                    <!-- <v-list-item @click="DELETE_ACCOUNT(link)">
                                                        <v-list-item-action><v-icon>delete</v-icon></v-list-item-action>
                                                        <v-list-item-title>Delete Account</v-list-item-title>
                                                    </v-list-item> -->
                                                        
                                                </v-list> 
                                            </v-menu>  
                                            <v-layout fill-height  align-center justify-center column> 
                                                
                                                <v-icon class="mt-3" size="50" color=" darken-">mdi-coffee-maker</v-icon>
                                            </v-layout>
                                            <v-img  v-if="false"  
                                                :src="link.image?link.image:MBS.data.noImg" >  
                                                <template v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"
                                                        ></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>  
                                            
                                        </v-card>
                                    </v-layout>  
                                </v-card>
                            </v-responsive>
                            <v-card-title >
                                <v-layout class="ma-0" >
                                    <div class="headline" >{{link.name}}</div> 
                                </v-layout>
                            </v-card-title> 
                        </v-card> 
                    </template>
                </v-hover>
            </v-flex>
        </v-layout> 
    </v-container>  
  </v-layout> 
</template>

<script>
import { mra,generateInvoiceNumber } from '../../../plugins/crypto';
import DATA from '../../../plugins/DATA'
import {mapState} from "vuex"
import { registerPlugin } from '@capacitor/core';
import moment from 'moment';
import { toNumber } from '../../../plugins/formatNumber';
const Z108Hardware = registerPlugin('Z108Hardware');
// const BluetoothPrinter = registerPlugin('BluetoothPrinter'); 
let PAGE_NAME = "MY-ACCOUNT"
    export default {
        name:PAGE_NAME, 
        data() {
            return {
                PAGE_SHOW:false, 
                DATA:DATA,
                devices:null,
                connectedAddress:null,
            }
        },
        created(){
          try {  
            this.MBS.events.$on('ON_LAN', this.ON_LAN); 
            
          } catch (error) {
            this.MBS.actions.error({
              error:error,
              from:'created',
              page:PAGE_NAME, 
            }) 
          }
        },
        mounted() {
            this.MBS.actions.header({
                show:true,
                type:'subToolbar', 
                
            })
            this.MBS.actions.subToolbar({
                show:true,
                height:70,
                flat:false,
                color:'primary',
                textColor:'white', 
                side:'right'
            }) 
            this.FEEDBACKS(500)

            this.refresh();
             
        },
        computed: {
            bus(){
                return {
                    listPairedDevices:this.listPairedDevices,
                    connect:this.connect,
                    connectedAddress:this.connectedAddress,
                    disconnect:this.disconnect,
                    reconnectIfSaved:this.reconnectIfSaved,
                    openPairingSettings:this.openPairingSettings,
                    devices:this.devices,
                }
            },  
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                online: state=> state.users['ONLINE_STATUS'],
                online_lan1: state=> state.lan['ONLINE_LAN1'],
                online_lan2: state=> state.lan['ONLINE_LAN2'],
                link_lan1: state=> state.lan['LINK_LAN1'],
                link_lan2: state=> state.lan['LINK_LAN2'],
            }),
            ...mapState({ 
                ItemOrders: state=> state.items[(DATA.ITEMS.ITEM_ORDERS.values).toUpperCase()],
                JoinedItemOrders: state=> state.join[(DATA.ITEMS.ITEM_ORDERS.values).toUpperCase()],
                LocalItemOrders: state=> state.items[(DATA.ITEMS.LOCAL_ITEM_ORDERS.values).toUpperCase()],
                JoinedLocalItemOrders: state=> state.join[(DATA.ITEMS.LOCAL_ITEM_ORDERS.values).toUpperCase()],
                ItemOrderOptions: state=> state.items[(DATA.ITEMS.ITEM_ORDER_OPTIONS.values).toUpperCase()],
                JoinedItemOrderOptions: state=> state.join[(DATA.ITEMS.ITEM_ORDER_OPTIONS.values).toUpperCase()], 
                Devices: state=> state.items[(DATA.ITEMS.DEVICES.values).toUpperCase()],
                JoinedDevices: state=> state.join[(DATA.ITEMS.DEVICES.values).toUpperCase()],
                LanItemOrders: state=> state.lan["LAN_ITEM_ORDERS"],
                JoinedLanItemOrders: state=> state.join["LAN_ITEM_ORDERS"],
                DaysShifts: state=> state.items[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()],
                JoinedDaysShifts: state=> state.join[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()], 
            }),   
            ItemOrdersData(){  
                return this.JoinedItemOrders?this.JoinedItemOrders:this.ItemOrders
            },  
            LocalItemOrdersData(){  
                return this.JoinedLocalItemOrders?this.JoinedLocalItemOrders:this.LocalItemOrders
            },  
            DevicesData(){
                return this.JoinedDevices?this.JoinedDevices:this.Devices
            },
            Printers(){
                let devices = this.DevicesData 
                if(!devices){return null}
                let printers = devices.filter(item=>{
                    return this.MBS.actions.TEXT_UP(item.device_type)
                     == this.MBS.actions.TEXT_UP(DATA.ITEMS.PRINTERS.value)
                }) 
                return printers
            },
            AllItemOrders(){  
                let local = this.LocalItemOrdersData
                let live = this.ItemOrdersData
                console.log(live,'l---------');
                return live
            },  
            ItemOrderOptionsData(){  
                return this.JoinedItemOrderOptions?this.JoinedItemOrderOptions:this.ItemOrderOptions
            }, 
            /////////
            MyLinks(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("orders",1,true) 
                return thisLinks
            },
            ProcessingOrders(){  
                const all_order_options = this.ItemOrderOptionsData  
                const processing_order_option = all_order_options?all_order_options.filter(order=>order.type_key=="processing_order"):null
                if(!processing_order_option){return null}
                let allLinks = []
                processing_order_option.forEach(element => {
                    allLinks.push({
                        ...element,
                        name:element.name,
                        link:this.MBS.actions.COMPANY_LINK("/orders/"+element.code,true),
                        icon:'link', 
                        image_background_color:'primary lighten-2',
                        image_size:'80',
                        
                    })
                });  
                return allLinks
            },
        },
        methods: { 
            //
            async listPairedDevices() {
                const { devices } = await BluetoothPrinter.listPairedDevices();
                this.devices = devices;
                return devices;
            },
            async connect(address) {
                this.connecting = true;
                this.error = null;
                console.log(address,'address.....');
                
                try {
                    await BluetoothPrinter.connect({ address });
                    this.connectedAddress = address;
                    console.log(this.connectedAddress,'connectedAddress...........');
                    
                    // localStorage.setItem(STORAGE_KEY, address);
                } catch (e) {
                    console.log(e,'Failed to connect.........');
                    
                    this.error = e.message || 'Failed to connect';
                    throw e;
                } finally {
                    this.connecting = false;
                }
            },
            async disconnect() {
            await BluetoothPrinter.disconnect();
            this.connectedAddress = null;
            localStorage.removeItem(STORAGE_KEY);
            },
            async reconnectIfSaved() {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved) {
                try { await this.connect(saved); } catch (e) { /* stays disconnected, user can retry */ }
            }
            },
            openPairingSettings() {
            return BluetoothPrinter.openBluetoothSettings();
            },
            ///
            refresh() { this.bus.listPairedDevices(); },
            clicked(){},
            async LAN_SET(){
                const link_lan2 = this.link_lan2
                console.log(link_lan2,'link_lan2..............');
                const orders = this.JoinedDaysShifts
                const Printers = this.Printers
                const order = orders?orders[0]:null
                const joined_cashups = order?.joined_cashups
                const cashup = joined_cashups?joined_cashups[0]:null

                const printer = Printers?Printers[1]:null
                console.log(order,'o++++++++++');
                console.log(orders,'orders++++++++++jj');
                console.log(cashup,'cashup++++++++++jj');
                console.log(printer,'printer++++++++++');

                const res = await this.MBS.actions.EPSON_CASHUP_REQUEST({
                    printer,
                    cashup:cashup,
                })
                console.log(res,'processed-------ss------------');
                
                this.$store.dispatch("lan_print",{
                    // print_data:{data:order,processed:false,join:false},
                    // print_data:{data:res?.data,processed:true,join:false},
                    printer:printer,
                    // print_link:link_lan2,
                    lan:2,
                    print_option:{
                        open_drawer:1,
                        // print_barcode:1,
                        // document_type:"dayshift",
                        // document_title:"Regis Sales"
                    } 
                }).then(res=>{
                    console.log(res,"res printer+++++++++");
                    
                })
                .catch(error=>{
                    console.log(error,'er/.......');
                    
                })
                
                
                // // this.MBS.events.$emit("PLAY_SOUND",)
                // // this.$store.dispatch("set_lan_link","http://192.168.1.193:1600/")
                // this.$store.dispatch("lan_set",{
                //     action:"test_data",
                //     name:"test", 
                //     data:{key:4,name:"testing item3"},
                // }).then(res=>{
                //     console.log(res,'res...');
                    
                // }).catch(error=>{
                //     console.log(error,'err...');
                // })
            },
            async Z108PRINTER(){
                try {
                    let receiptData =    [
                        {
                            "align": "center",
                            "bold": false,
                            "value": "top_header",
                            "text": "*** SALES RECEIPT ***"
                        },
                        {
                            "align": "center",
                            "bold": true,
                            "value": "company_name",
                            "text": "A RESTAURANT"
                        },
                        {
                            "align": "center",
                            "bold": false,
                            "value": "company_post_address",
                            "text": "Address: undefined"
                        },
                        {
                            "align": "center",
                            "bold": false,
                            "value": "company_email_address",
                            "text": "Email: ."
                        },
                        {
                            "align": "center",
                            "bold": false,
                            "value": "company_phone_number",
                            "text": "(Cell): 0993259202"
                        },
                        {
                            "align": "center",
                            "bold": false,
                            "value": "company_tpin",
                            "text": "TIN: undefined"
                        },
                        {
                            "align": "center",
                            "bold": false,
                            "value": "company_tpin",
                            "text": "undefined Teller: Regis"
                        },
                        {
                            "align": "center",
                            "bold": false,
                            "value": "top_header",
                            "text": "******"
                        },
                        {
                            "text": " "
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "RECEIPT KEY:             1773113750337"
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "DATE:                       2026/03/10"
                        },
                        {
                            "text": " "
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "GOURMET CHEESEBURGER DOUB   25,000.00 "
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "LE PATTY QTY:1 X 25,000.00            "
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "PHILLY CHICKEN SANDWICH     22,500.00 "
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "QTY:1 X 22,500.00                     "
                        },
                        {
                            "value": "line"
                        },
                        {
                            "align": "left",
                            "bold": true,
                            "double": true,
                            "value": "",
                            "text": "TOTAL:    47,500.00"
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "CASH:                        47,500.00"
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "CHANGE:                           0.00"
                        },
                        {
                            "align": "center",
                            "bold": true,
                            "barcode": true,
                            "text": "SA1773113750337"
                        },
                        {
                            "align": "left",
                            "bold": false,
                            "value": "",
                            "text": "DATE:2026/03/10             TIME:05:35"
                        },
                        {
                            "value": "line"
                        },
                        {
                            "align": "center",
                            "bold": true,
                            "text": "***POWERED BY KIPCOUNT***"
                        },
                        {
                            "align": "center",
                            "bold": true,
                            "text": "***+265993259202***"
                        },
                        {
                            "value": "line"
                        }
                    ]

                    console.log( await BluetoothPrinter.isConnected(),".isConnected().......");
                    
                    await BluetoothPrinter.printReceipt({lines:receiptData});

                    console.log("Printer S...........: ");
                } catch (e) {
                    // alert("Printer Error: " + e.message);
                    console.log("Printer Error: " + e.message); 
                }
                 
            },
            test_mra(event){
                // const detail = { 
                //     taxpayerId:10759, 
                //     terminalPosition:1, 
                //     transactionDate:null, 
                //     transactionCount:2
                // }
                // const res = mra()
                // console.log(res,'test_mra.................');
                // console.log(detail,'detail.................');
                // const invoice = generateInvoiceNumber(detail)
                // console.log(invoice,'invoice...........++......');

                let  GET_PERIOD_KEYS = (dayShiftKey) =>{
                    const dayMoment = moment(toNumber(dayShiftKey)); 
                    const dayKey = dayMoment.format('YYYY-MM-DD');
                    const weekKey = dayMoment.clone().startOf('isoWeek').format('YYYY-MM-DD');
                    const monthKey = dayMoment.format('YYYY-MM');
                    // return { dayKey, weekKey, monthKey };
                    return {
                        day: dayKey,
                        week: weekKey,
                        month: monthKey,
                        dayKey: String(moment(dayKey).valueOf()),
                        weekKey: String(moment(weekKey).valueOf()),
                        monthKey: String(moment(monthKey).valueOf())
                    };
                }
                console.log(GET_PERIOD_KEYS("1779845420143"),"1779845420143");
                console.log(GET_PERIOD_KEYS(1782381660722),"1782381660722");
                console.log(GET_PERIOD_KEYS(),".....");
                
                
            }, 
            ON_LAN(event){
                console.log(event,'ON_LAN.................');
                
            },
            //LOAD
            EXIT_PAGE(){
                if (!this.us) {
                    this.MBS.actions.go("/")
                }else{
                    this.PAGE_SHOW = true
                }
            },
            FEEDBACKS(time=400){ 
                setTimeout(()=>{
                    let us = this.us 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses 

                    //CHECK USER STATE 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        }) 

                        if (logging) {
                            this.PAGE_SHOW =false
                        }else{
                            this.EXIT_PAGE()
                        }     
                    }else{
                       this.EXIT_PAGE()
                    }

                     
                },time)
            }
        },
        watch: { 
            us(v){
                this.FEEDBACKS()
            },
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            } 
        },
  }
</script>
 
